import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { StammdatenService } from '../../stammdaten.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { Subscription } from 'rxjs';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { Client } from '../../../client/classes/client';
import { Benutzerprofil } from '../../mein-profil/mein-profil';
import { FormControl } from '@angular/forms';
import { AppService } from '../../../../services/app/app.service';

@Component({
    selector: 'kiene-haendler-favoriten',
    templateUrl: './haendler-uebersicht.component.html',
    styleUrls: ['./haendler-uebersicht.component.scss'],
})
export class HaendlerUebersichtComponent implements OnInit, OnDestroy {
    favoritenHaendler: Client[];
    haendlerFehlt = this.stammdatenService.getHaendlerFehlt();
    watchHaendlerFehltSub: Subscription;
    haendlerFavoritenSubscription: Subscription;
    @Input('showReturnButton') showReturnButton = true;

    benutzerprofil = new Benutzerprofil();
    searchControl = new FormControl('');

    constructor(
        private readonly stammdatenService: StammdatenService,
        private readonly messageService: MessageService,
        private readonly api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly appService: AppService,
    ) {}

    ngOnInit(): void {
        this.ladeBenutzerprofil();
        this.ladeFavoriten();

        this.watchHaendlerFehltSub = this.stammdatenService.watchHaendlerFehlt().subscribe(fehlt => {
            this.haendlerFehlt = fehlt;
        });
    }

    ngOnDestroy(): void {
        this.watchHaendlerFehltSub?.unsubscribe();
        this.haendlerFavoritenSubscription?.unsubscribe();
    }

    ladeFavoriten(): void {
        this.haendlerFavoritenSubscription?.unsubscribe();
        this.haendlerFavoritenSubscription = this.stammdatenService.loadHaendler().subscribe({
            next: data => {
                this.favoritenHaendler = [];
                this.favoritenHaendler = (data.records ?? []).map(h => ({
                    ...h,
                    bezeichnung: h?.name ?? h?.bezeichnung,
                    betrieb_id: h?.viehhaendler_id ?? h?.betrieb_id,
                }));
            },
            error: (err: any) => {
                this.messageService.errorMessage('Fehler beim Laden aller Händler', err);
            },
        });
    }

    ladeBenutzerprofil() {
        this.api.get(`${this.apiBaseUrl}benutzerprofil/read_one_kundenportal.php`).subscribe({
            next: (response: Benutzerprofil) => {
                this.benutzerprofil = response;
            },
            error: err => {
                this.messageService.errorMessage('Profil konnte nicht geladen werden!', err);
            },
        });
    }

    sendMail(haendler: Client) {
        if (haendler.email) {
            const htmlAnchorElement = document.createElement('a');
            htmlAnchorElement.style.display = 'none';
            htmlAnchorElement.href = 'mailto:' + haendler.email;
            document.body.appendChild(htmlAnchorElement);
            htmlAnchorElement.click();
        }
    }

    getFilteredHaendler(): Client[] {
        const list = this.favoritenHaendler ?? [];
        const query = (this.searchControl.value ?? '').toString().trim().toLowerCase();
        if (!query) {
            return list;
        }
        return list.filter(h => {
            const name = (h?.bezeichnung ?? '').toLowerCase();
            const vvvo = (h?.vvvo ?? '').toLowerCase();
            const adresse = this.getAdresse(h).toLowerCase();
            const email = (h?.email ?? '').toLowerCase();
            return name.includes(query) || vvvo.includes(query) || adresse.includes(query) || email.includes(query);
        });
    }

    getAdresse(h: Client): string {
        return `${h?.strasse ?? ''}${h?.strasse && (h?.plz || h?.ort) ? ', ' : ''}${h?.plz ?? ''} ${h?.ort ?? ''}`.trim();
    }

    get isMobileScreen(): boolean {
        return this.appService.isMobileScreen;
    }
}
